import React from "react";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";


const Registration = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-800 md:text-xl xl:text-2xl flex md:flex-row flex-col no-wrap md:p-3 md:m-10 lg:m-14 p-2 m-2 justify-around text-white md:flex-wrap">
        <div className="p-4 w-full flex flex-col justify-between">
          <Typography variant="h4" sx={{fontWeight: 800}}>Submission</Typography>
          The submission for high-quality abstract of original research on advanced manufacturing and materials for sustainable mining equipment and technologies is due by 31 Aug 2025. Topics of interest include, but are not limited to: <strong>Composite materials manufacturing; Design of advanced materials; AI application in materials manufacturing; modelling of materials manufacturing; tribology; design of advanced mining equipment; artificial intelligence and data-driven solutions for mining equipment utilisation; mine automation and digital mining; safety, maintainability and monitoring of mining equipment; green mining technologies; advanced equipment for the mining industry; green manufacturing processing and other topics relevant to innovative composites and mining technologies.</strong> 
        </div>
        <div className="flex flex-row justify-between w-full flex-wrap gap-4 p-4">
          <a href="/conference/abstractTemplateAMMET2025.docx" download>
            <Button variant="outlined" color="secondary" sx={{bgcolor: "#EB9A3E", "&:hover": {"bgcolor": "#EB9A3E"}, width: "200px", height:"60px", borderRadius: 0, border: 0, fontWeight: 1000}}>
              Abstract Template
            </Button>
          </a>
          <Button onClick={() => {navigate('/abstract-submission')}} variant="outlined" color="secondary" sx={{bgcolor: "#EB9A3E", "&:hover": {"bgcolor": "#EB9A3E"}, width: "200px", height:"60px", borderRadius: 0, border: 0, fontWeight: 1000}}>Abstract Submission</Button>
        </div>
    </div>
  );
};

export default Registration;